import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { fetchRoles } from '../services/roles';
import type { RoleListParams, RoleSummary, RoleUsersParams } from '../types/roles.types';

export const roleKeys = {
  all: ['roles'] as const,
  lists: () => [...roleKeys.all, 'list'] as const,
  list: (params: RoleListParams) => [...roleKeys.lists(), params] as const,
  detail: (id: string) => [...roleKeys.all, 'detail', id] as const,
  users: (id: string, params: RoleUsersParams) => [...roleKeys.detail(id), 'users', params] as const,
};

export const useRolesQuery = (params: RoleListParams = {}) =>
  useQuery<RoleSummary[]>({
    queryKey: roleKeys.list(params),
    queryFn: () => fetchRoles(params),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
